<template>
    <div class="enterprise-add-or-update">
        <el-dialog
            :title="enterprise.id == 0 ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="enterpriseDialog"
            @close="enterpriseClose"
        >
            <el-form
                :inline="true"
                ref="enterpriseRef"
                :model="enterprise"
                :rules="enterpriseRules"
                label-width="100px"
                @keyup.enter.native="enterpriseSubmit()"
            >
                <el-form-item label="企业名称" prop="title">
                    <el-input
                        v-model="enterprise.title"
                        placeholder="请输入企业名称"
                    ></el-input>
                </el-form-item>
                <el-form-item label="企业地址" prop="address">
                    <el-input
                        v-model="enterprise.address"
                        placeholder="请输入企业地址"
                    ></el-input>
                </el-form-item>
                <el-form-item label="联系人" prop="concatPeople">
                    <el-input
                        v-model="enterprise.concatPeople"
                        placeholder="请输入联系人"
                    ></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="mobile">
                    <el-input
                        v-model="enterprise.mobile"
                        placeholder="请输入手机号码"
                    ></el-input>
                </el-form-item>
                <el-form-item label="电话号码" prop="phone">
                    <el-input
                        v-model="enterprise.phone"
                        placeholder="请输入电话号码"
                    ></el-input>
                </el-form-item>
                <el-form-item label="电子邮箱" prop="email">
                    <el-input
                        v-model="enterprise.email"
                        placeholder="请输入电子邮箱"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="企业网站"
                    prop="website"
                    class="input-style"
                >
                    <el-input
                        v-model="enterprise.website"
                        placeholder="请输入企业网站"
                    ></el-input>
                </el-form-item>
                <el-form-item label="城市地区" prop="cityCode">
                    <el-select
                        v-model="enterprise.cityCode"
                        clearable
                        placeholder="请选择城市"
                    >
                        <el-option
                            v-for="item in codeListArr"
                            :key="item.id"
                            :label="item.areaName"
                            :value="item.code"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="年度" prop="annual">
                    <el-date-picker
                        v-model="enterprise.annual"
                        type="year"
                        value-format="yyyy"
                    >
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="企业类型" prop="cityCode">
                    <el-select
                        v-model="enterprise.type"
                        clearable
                        placeholder="请选择企业类型"
                    >
                        <el-option
                            v-for="item in enterpriseTypeArr"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="企业介绍" prop="content">
                    <el-button
                        type="info"
                        icon="el-icon-edit"
                        size="small"
                        @click="openRichDialog"
                        >前往编写企业介绍</el-button
                    >
                </el-form-item>
                <el-form-item label="企业描述" class="describe-enterprise">
                    <el-input
                        type="textarea"
                        :rows="3"
                        placeholder="请输入内容"
                        v-model="enterprise.description"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="企业logo" prop="thumb">
                    <el-upload
                        class="upload"
                        ref="upload"
                        :action="uploadUrl"
                        name="file"
                        :limit="1"
                        accept=".png,.jpg"
                        :on-remove="handleRemove"
                        :before-upload="beforeUpload"
                        :on-success="handleSuccess"
                        :file-list="fileList"
                        list-type="picture"
                    >
                        <el-button slot="trigger" size="small" type="primary"
                            >选取文件</el-button
                        >

                        <div slot="tip" class="el-upload__tip">
                            只能上传 .png .jpg图片，且不超过10MB
                        </div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <el-button
                type="primary"
                @click="enterpriseSubmit"
                :style="{ marginLeft: '30px' }"
                >提交</el-button
            >
            <el-button @click="enterpriseDialog = false">取消</el-button>
            <!-- 企业介绍对话框 -->
            <el-dialog
                width="50%"
                title="企业介绍"
                :visible.sync="innerVisible"
                append-to-body
                @closed='destroyEdit'
            >
                <div id="demo1"></div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="innerVisible = false"
                        >确 定</el-button
                    >
                </span>
            </el-dialog>
        </el-dialog>
    </div>
</template>

<script>
import getCityCode from "@/utils/cityCode.js";
// 引入过滤函数
import { showcontent } from "@/utils/method.js";
// 引入 wangEditor
import wangEditor from "wangeditor";
export default {
    data() {
        return {
            enterprise: {
                id: null,
                title: "",
                address: "",
                concatPeople: "",
                mobile: "",
                phone: "",
                email: "",
                website: "",
                annual: "",
                cityCode: "",
                type: "",
                content: "",
                description: "",
                thumb: "",
            },
            // 当前对话框的显示与隐藏
            enterpriseDialog: false,
            innerVisible: false,
            // 城市编码对象数组
            codeListArr: [],
            // 示范企业类型数组
            enterpriseTypeArr: [
                { name: "数字商务企业", id: "0" },
                { name: "国家级电商示范企业", id: "1" },
                { name: "省级电商示范企业", id: "2" },
            ],
            editor: null,
            uploadUrl: "",
            fileList: [],
            // 表单校验规则
            enterpriseRules: {
                title: [
                    {
                        required: true,
                        message: "请输入企业名称",
                        trigger: "blur",
                    },
                ],
                address: [
                    {
                        required: true,
                        message: "请输入企业地址",
                        trigger: "blur",
                    },
                ],
                mobile: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: "blur",
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入企业联系方式",
                        trigger: "blur",
                    },
                ],
                email: [
                    {
                        required: true,
                        message: "请输入企业邮箱",
                        trigger: "blur",
                    },
                ],
                cityCode: [
                    {
                        required: true,
                        message: "请选择城市地区",
                        trigger: "blur",
                    },
                ],
                type: [
                    {
                        required: true,
                        message: "请输入企业类型",
                        trigger: "blur",
                    },
                ],
                content: [
                    {
                        required: true,
                        message: "请输入企业简介",
                        trigger: "blur",
                    },
                ],
                thumb: [
                    {
                        required: true,
                        message: "请输入企业图像",
                        trigger: "blur",
                    },
                ],
                annual: [
                    {
                        required: true,
                        message: "请输入企业批次",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    created() {
        getCityCode().then((data) => {
            this.codeListArr = data[1];
        });
    },
    methods: {
        init(id) {
            this.enterprise.id = id || 0;
            this.enterpriseDialog = true;
            this.uploadUrl = 'https://activity.suhoo.net/api/upload/image';
            if (this.enterprise.id) {
                this.getDetailEnterprise();
            }
        },
        // 点击提交按钮触发事件
        enterpriseSubmit() {
            this.$refs.enterpriseRef.validate((valid) => {
                if (valid) {
                    this.enterprise.annual =
                        parseInt(this.enterprise.annual) -
                        1 +
                        "," +
                        this.enterprise.annual;
                    this.$ajaxPost(
                        `/demoEnterprise/${
                            this.enterprise.id ? "update" : "save"
                        }`,
                        this.enterprise
                    ).then(({ data }) => {
                        if (data.code === 0) {
                            this.enterpriseDialog = false;
                            this.$emit("enterpriseUpdated");
                            this.$message.success('保存成功')
                        }
                    });
                }
            });
        },
        // 点击编写企业介绍按钮
        openRichDialog() {
            this.innerVisible = true;
            if (!this.editor) {
                this.$nextTick(() => {
                    // 创建富文本编辑器实例
                    const editor = new wangEditor("#demo1");
                    // 配置 onchange 回调函数，将数据同步到 vue 中
                    editor.config.onchange = (newHtml) => {
                        this.enterprise.content = newHtml;
                    };
                    editor.config.uploadImgServer = this.uploadUrl;
                    editor.config.showLinkImg = false;
                    editor.config.uploadFileName = "file";
                    editor.config.uploadImgHooks = {
                        customInsert: function (insertImg, result, editor) {
							let url = (result.data.fileInfo.domain ? result.data.fileInfo.domain+'/' : 'https://activity.suhoo.net/')+result.data.fileInfo.file_path;
							insertImg(url);
                        }
                    }
                    // editor.config.customUploadImg = function (
                    //     resultFiles,
                    //     insertImgFn
                    // ) {
                    //     let objectURL = URL.createObjectURL(resultFiles[0]);
                    //     insertImgFn(objectURL);
                    // };
                    // 创建编辑器
                    editor.create();
                    if (this.enterprise.content !== "") {
                        editor.txt.html(
                            showcontent(showcontent(this.enterprise.content))
                        );
                        // editor.txt.html(this.activities.context);
                    }
                    this.editor = editor;
                });
            }
        },
        //关闭企业介绍后销毁编辑器
        destroyEdit(){
            if(this.editor){
                this.editor.destroy()
                this.editor = null
            }
        },
        // 关闭添加/更新示范企业对话框的事件
        enterpriseClose() {
            this.$refs.enterpriseRef.resetFields();
            this.fileList = [];
            Object.keys(this.enterprise).forEach((item) => {
                if (item === "id") {
                    this.enterprise[item] = null;
                } else {
                    this.enterprise[item] = "";
                }
            });
        },
        // 根据id获取企业详细信息
        getDetailEnterprise() {
            this.$ajaxPost(
                `/demoEnterprise/info/open/${this.enterprise.id}`,
                {}
            ).then(({ data }) => {
                if (data.code === 0) {
                    // 将data中的enterprise属性遍历，将值显示在表单中
                    Object.keys(this.enterprise).forEach((item) => {
                        // this.enterprise[item] = showcontent(
                        //     showcontent(data.data[item])
                        // );
                        if (item === "content") {
                            this.enterprise[item] = data.data[item];
                            for (let i = 1; i < 10; i++) {
                                this.enterprise[item] = showcontent(
                                    this.enterprise[item]
                                );
                            }
                        } else {
                            this.enterprise[item] = showcontent(
                                showcontent(data.data[item])
                            );
                        }
                    });
                    console.log(this.enterprise);
                    // 将图片展示
                    if (this.enterprise.thumb) {
                        const obj = {
                            url: this.enterprise.thumb,
                        };
                        this.fileList = [obj];
                    }
                    // 将annual字段过滤
                    if (this.enterprise.annual !== "") {
                        const arr = this.enterprise.annual.split(",");
                        this.enterprise.annual = arr[arr.length - 1];
                    }
                }
            });
        },
        // ==============图片上传相关方法=========

        // 从本地保存的上传目录中删除图片路径
        handleRemove() {
            this.enterprise.thumb = "";
        },
        beforeUpload(file) {
            const isLt100M = file.size / 1024 / 1024 < 10;
            if (!isLt100M) {
                this.$message.error("上传文件大小不能超过 10MB!");
            }
            return isLt100M;
        },
        handleSuccess(response) {
            if (response && response.code === 0) {
                console.log(response);
                console.log("文件上传成功返回结果：", response.data);
				let url = (response.data.fileInfo.domain ? response.data.fileInfo.domain+'/' : 'https://activity.suhoo.net/')+response.data.fileInfo.file_path;
                this.enterprise.thumb = url;
            }
        },
    },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
    .el-form-item {
        margin-bottom: 10px;
        width: 48%;
    }
    .input-style,
    .describe-enterprise {
        width: 100%;
        .el-form-item__content {
            width: 71%;
        }
    }
}
/deep/ .el-upload-list--picture {
    .el-upload-list__item {
        width: 92px;
        height: 92px;
    }
}
/deep/ .el-form-item__error {
    padding-top: 0;
}
</style>